import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RequestSubtasksComponent } from './request-subtasks.component';
import { SharedModule } from '../../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
@NgModule({
    declarations: [RequestSubtasksComponent],
    imports: [CommonModule, FormsModule, TranslateModule, SharedModule, MatIconModule, MatDatepickerModule, NgxMatDatetimePickerModule],
    exports: [RequestSubtasksComponent],
})
export class RequestSubtasksModule {}
